import React from "react";
import Modal from "antd/es/modal/Modal";
import {useTranslation} from "react-i18next";


export default function ModalWindow () {
    const {t} = useTranslation();

    const errorConnect = () => {
        return (
            Modal.error({
                title: t('error'),
                content: t('e_connect'),
            })
        )
    }

    const noPermission = () => {
        return (
            Modal.error({
                title: t('error'),
                content: t('no_permission'),
            })
        )
    }

    return {
        errorConnect,
        noPermission
    }
}
